import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
@Component({
  selector: 'app-cblog',
  templateUrl: './cblog.component.html',
  styleUrls: ['./cblog.component.sass']
})
export class CblogComponent implements OnInit {

  error: any = { 'name': '' };
  privacy_list:any=[];
  component = "";
  application = "";
  btn_process = false;
  appCreateForm: FormGroup;
  selected_category = "";
  constructor(private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "blog";
    this.appCreateForm = this.fb.group({
      name: [],
      privacy:['public'],
      description: []
    });
    let THIS = this;
    let p = {
      'component': this.component,
      'application': 'category',
      'categoryType': this.application
    };
    this._categoryService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let result = this._global.getVal(data, 'response', '');
          CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", '', this.application, true);
          $("div#" + this.application + "_category").click(function (e) {
            var $target = $(e.target);
            if ($target.attr("id") === "categoryCheck") {
              THIS.selected_category = Helper.categoryJsonText("categoryCheck");
            }
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
      let f = {
        'component': this.component,
        'application': this.application
      };
      this._formdataService.common(f, 'mediaVisibility').subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.privacy_list = this._global.getVal(data, 'response', '');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
  }

  ngOnInit() {
  }
  save() {
    this.error = { 'name': '' };
    this.btn_process = true;
    let r = this.appCreateForm.value;
    r.component = this.component;
    r.application = this.application;
    r.mediaType = this.application;
    r.status="active";
    let p = this._global.paramsRemoveNull(r);
    p.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');
    this._saveService.app(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
}
